import React, {useEffect, useState} from "react";
import {
    CommandBar, Pivot, PivotItem,
    PrimaryButton,
} from "@fluentui/react";

import useCan, {CATALOG_MODIFY} from "../../permissions/ability"
import GridComposer from "../../components/GridComposer/GridComposer";
import {
    useGetMergedProductCategoriesQuery, useGetMergedProductSegmentsQuery
} from "../../store/endpoints/ProductCategorizationEndpoints";
import {GridSelectionMode, IColumnDetails} from "../../models/GridConfiguration";
import {IProductCategory, IProductSegment} from "../../models/Storefront";
import ProductCategoryDetailsPanel from "../../components/ProductCategorization/ProductCategoryDetailsPanel";
import ProductSegmentDetailsPanel from "../../components/ProductCategorization/ProductSegmentDetailsPanel";


const CategoryManagementPage: React.FC = () => {
    const [categoryPage, setCategoryPage] = useState<number>(1)
    const [categoryPageSize, setCategoryPageSize] = useState<number>(100)
    const [categoryFilter, setCategoryFilter] = useState<string>()
    const [categoryFilterField, setCategoryFilterField] = useState<string>()
    const [categorySortBy, setCategorySortBy] = useState<string>()
    const [categorySortDirection, setCategorySortDirection] = useState<string>()
    const [segmentPage, setSegmentPage] = useState<number>(1)
    const [segmentPageSize, setSegmentPageSize] = useState<number>(100)
    const [segmentFilter, setSegmentFilter] = useState<string>()
    const [segmentFilterField, setSegmentFilterField] = useState<string>()
    const [segmentSortBy, setSegmentSortBy] = useState<string>()
    const [segmentSortDirection, setSegmentSortDirection] = useState<string>()
    const customCategories = useGetMergedProductCategoriesQuery({ conditions:{page: categoryPage, pageSize: categoryPageSize, searchTerm: categoryFilter, searchBy: categoryFilterField, sortBy: categorySortBy, sortDirection: categorySortDirection}})
    
    const customSegments = useGetMergedProductSegmentsQuery({ conditions:{page: segmentPage, pageSize: segmentPageSize, searchTerm: segmentFilter, searchBy: segmentFilterField, sortBy: segmentSortBy, sortDirection: segmentSortDirection}})

    const [categoryModalOpen, setCategoryModalOpen] = useState(false);
    const [segmentModalOpen, setSegmentModalOpen] = useState(false);

    const [categoryContextSelectedCategory, setCategoryContextSelectedCategory] = useState<string>()
    const [categoryContextSelectedSegment, setCategoryContextSelectedSegment] = useState<string>()
    
    const [segmentContextSelectedSegment, setSegmentContextSelectedSegment] = useState<string>()
    
    

    const getCustomCategoryColumns = () => {
        const columnDetails: IColumnDetails[] = [
            {
                index: 0,
                identifier: 'Details',
                label: '',
                type: '',
                effectiveWidth: 100,
                component:() => <PrimaryButton label={'Details'}>Details</PrimaryButton>,
                onClick: (cat: IProductCategory) => {
                    setCategoryContextSelectedCategory(() => cat.identifier)
                    setCategoryContextSelectedSegment(cat.segmentId)
                    setCategoryModalOpen(true);
                },
                required: true,
            }
        ];
        return columnDetails
    }
    const getCustomSegmentColumns = () => {
        const columnDetails: IColumnDetails[] = [
            {
                index: 0,
                identifier: 'Details',
                label: '',
                type: '',
                effectiveWidth: 100,
                component:() => <PrimaryButton label={'Details'}>Details</PrimaryButton>,
                onClick: (segment: IProductSegment) => {
                    setSegmentContextSelectedSegment(segment.identifier)
                    setSegmentModalOpen(true);
                },
                required: true,
            }
        ];
        return columnDetails
    }
    

    const canModify = useCan(CATALOG_MODIFY);

    return (
        <div className="main-content">
            <h1>Product Category Management</h1>
            {canModify && (
                <CommandBar items={[]} farItems={[]} />
            )}
            <Pivot overflowBehavior='menu' styles={{itemContainer: {marginTop: '1em'}}}>
                <PivotItem headerText='Categories'>

                    {(categoryContextSelectedCategory && categoryContextSelectedSegment) &&
                    <ProductCategoryDetailsPanel isOpen={categoryModalOpen} categoryIdentifier={categoryContextSelectedCategory} segmentIdentifier={categoryContextSelectedSegment} onDismiss={() => setCategoryModalOpen(false)}/>
                    }
                    <GridComposer
                        canChangePageSize={true}
                        page={categoryPage}
                        onPageChange={setCategoryPage}
                        onPageSizeChange={setCategoryPageSize}
                        columnSetName={'ProductCategory'}
                        data={customCategories?.data ?? {}} 
                        loading={customCategories.isLoading || customCategories.isFetching} 
                        selectionMode={GridSelectionMode.none}
                        filter={categoryFilter}
                        filterField={categoryFilterField}
                        sortBy={categorySortBy}
                        sortDirection={categorySortDirection}
                        overrideColumns={getCustomCategoryColumns()}
                        onSort={(column, direction) => {
                          setCategorySortBy(() => column)
                          setCategorySortDirection(() => direction)
                        }}
                        onFilter={(filter, column) => {
                          setCategoryFilter(() => filter)
                          setCategoryFilterField(() => column)
                        }}
                        initialPageSize={100}
                        getItemId={(item: IProductCategory) => item.id}
                    />
                </PivotItem>
                <PivotItem headerText='Segments'>
                    {(segmentContextSelectedSegment) &&
                        <ProductSegmentDetailsPanel isOpen={segmentModalOpen} segmentIdentifier={segmentContextSelectedSegment} onDismiss={() => setSegmentModalOpen(false)}/>
                    }
                    <GridComposer
                        page={segmentPage}
                        onPageChange={setSegmentPage}
                        onPageSizeChange={setSegmentPageSize}
                        columnSetName={'ProductSegment'}
                        data={customSegments?.data ?? {}}
                        loading={customSegments.isLoading || customSegments.isFetching}
                        selectionMode={GridSelectionMode.none}
                        filter={segmentFilter}
                        filterField={segmentFilterField}
                        sortBy={segmentSortBy}
                        sortDirection={segmentSortDirection}
                        overrideColumns={getCustomSegmentColumns()}
                        onSort={(column, direction) => {
                            setSegmentSortBy(() => column)
                            setSegmentSortDirection(() => direction)
                        }}
                        onFilter={(filter, column) => {
                            setSegmentFilter(() => filter)
                            setSegmentFilterField(() => column)
                        }}
                        initialPageSize={100}
                        getItemId={(item: IProductSegment) => item.id ?? ''}
                    />
                    
                </PivotItem>
            </Pivot>
        </div>
    );
}

export default CategoryManagementPage;
